<template>
  <router-view />
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuth } from './composables/useAuth';

const { restoreSession } = useAuth();

onMounted(() => {
  restoreSession();
});
</script>

<style>
/* Styles globaux déjà importés via style.css */
</style>
